import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GetLegenda {
  dados: Array<GetLegendaItem>
}

export interface GetLegendaItem {
  cor: string,
  descricao: string,
  status: string
}

@Injectable({
  providedIn: 'root'
})
export class LegendaService {

  private relativeLink = 'legenda';

  constructor(private http: HttpClient) { }

  getLegenda(rotina: string,tabela:string): Observable<GetLegenda> {
    return this.http.get(`${environment.protheus}/${this.relativeLink}?rotina=${rotina}&tabela=${tabela}`) as Observable<GetLegenda>;
  }
}
